import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AppStore from '../../stores/AppStore';
import GuestSubmitButton from '../../components/guest-submit-button';
import {
  formatAmount,
  getPhoneNumberWithoutCountryCode,
  getGriffinPhoneHandler,
} from '../../utility/formator';
import templateData, {
  guestLocalsMessages,
  localsMessages,
} from '../../utility/getTemplateData';
import * as DonateAppActions from '../../actions/AppActions';
import { guestPayment as teslaGuestPayment } from './teslaHelper';
import { withRouter } from 'react-router-dom';
import withDonate from '../../components/guest/WithDonate';
import ThreeDSContainer from '../../components/threeDS/ThreeDSContainer';
import * as AppConstants from '../../utility/constants';
import AppDispatcher from '../../dispatcher/AppDispatcher';
import { isTeslaErrorMessage } from '../../utility/teslaUtility';
import * as FPT from '../../utility/fpt';
import { getSpecificCardSpec } from '../../utility/card-utils';
import _get from 'lodash/get';
import _find from 'lodash/find';
import _every from 'lodash/every';
import { red500 } from '@paypalcorp/pp-react-colors';
import { waitForElementToDisplay } from '../../utility/helper';
import { startCustomCPLTrackingForConfirmationPage } from '../../utility/cpl';

let SignupApp;
let signUpAppEvents;

const initialData = JSON.parse(
  document.getElementById('initialData').innerHTML || {}
);
const cardSpecs = _get(initialData, 'cardSpecs');
const allGuestMessages = guestLocalsMessages();

const landingErrorMessages = localsMessages('errors/landingerror');
const { error: { sendDonationNotAllowed } = {} } = ({} = landingErrorMessages);

export class TeslaForm extends Component {
  constructor(props) {
    super(props);

    SignupApp = props.signupApp;

    signUpAppEvents = props.signUpAppEvents;
    this.addSignUpAppListeners();
    this.state = {
      listenerIds: [
        'cardData_cardNumber',
        'cardData_csc',
        'paypalAccountData_donateCountryselector',
        'paypalAccountData_shareAddress',
      ],
      formattedAmount: this.getFormattedAmount(),
      hasLogo: templateData.hasLogo,
      subHeaderLabel: templateData.donationName,
      orgName: templateData.charityName,
      donationId: templateData.donationId,
      guestRedirectUrl: templateData.guestRedirectUrl,
      donateDisabled: false,
      showServiceErrors: false,
      errorMessages: [],
      recurringEnabled: templateData.recurringEnabled,
      recurringStatus: false,
      country: initialData.selectedCountry,
      selectedCountry: initialData.selectedCountry,
      charityCountry: templateData.charityCountry,
      memberMandatory: templateData.memberMandatory || false,

      recurringHelpText: '',
      recurringLabel: 'Make this a monthly donation',
      isShipping: templateData.isShipping || false,
      shareAddress: false,
      programNames: templateData.donateContext.program_names,
      entry: this.isFirstTimeEntry(),
    };

    this.dispatcherMessages = AppDispatcher.register((payload) => {
      const actionType = _get(payload, 'action.actionType');

      if (actionType === AppConstants.CHANGE_RECURRING) {
        const status = _get(payload, 'action.item.recurring', '') === 'checked';

        if (!this.state.memberMandatory) {
          const value = {
            paypalAccountData_memberMandatory: {
              visible: !status,
              value: status,
            },
            password_TCPA_Fields_dynamicSection: status,
            paypalAccountData_guestTermsAgree: { visible: !status },
            paypalFormData_paragraphOne: { visible: !status },
            paypalFormData_fieldGroupHeading: { visible: status },
          };

          if (templateData.onboardingEnableSkipAuth) {
            value.cardData_skipAuth = {
              name: '/cardData/skipAuth',
              fieldId: 'cardData_skipAuth',
              value: true,
              serverPayload: true,
              basedOnFieldId: 'paypalAccountData_memberMandatory',
            };
          }

          this.dispatchToSignUpApp({
            type: 'UPDATE_EXTERNAL_VALUES',
            value,
          });
        }
      }
    });
  }

  isFirstTimeEntry() {
    // Case 1: No saved token
    if (!templateData.tokenForSavedFormData) {
      return true;
    }

    // case 2: tesla form not visited
    if (!templateData.teslaVisited) {
      return true;
    }

    // case 3: current token is equal to the saved token in session
    if (
      templateData.token === templateData.tokenForSavedFormData &&
      templateData.teslaVisited
    ) {
      return false;
    }

    return true;
  }

  /**
   * Subscribe to signUpApp's event listeners
   */
  addSignUpAppListeners() {
    if (!document) {
      return;
    }

    document.addEventListener(
      signUpAppEvents.CLIENT_LISTENER_NAME,
      this.handleTeslaEvents,
      false
    );
  }

  dispatchToSignUpApp(action) {
    if (!document) {
      // progressiveComponent has to be loaded before dispatching events
      return;
    }

    document.dispatchEvent(
      new CustomEvent(signUpAppEvents.APP_LISTENER_NAME, {
        detail: action,
      })
    );
  }

  /**
   * Clean up signUpApp's event listeners when component will be UnMounted
   */
  removeSignUpAppListeners() {
    if (!document) {
      return;
    }

    document.removeEventListener(
      signUpAppEvents.CLIENT_LISTENER_NAME,
      this.handleTeslaEvents,
      false
    );
  }

  handleTeslaEvents = (e) => {
    if (e && e.detail) {
      this.handleSignUpAppEvents(e.detail);
    }
  };

  handleSignUpAppEvents = (action) => {
    switch (action.type) {
      case signUpAppEvents.VIEW_STATUS:
        if (this.state.entry) {
          this.setInitialState();
        }
        this.props.toggleSpinner();

        // Wait for the form to be visible
        waitForElementToDisplay(
          '#paypalAccountData_donateCountryselector',
          100,
          () => {
            if (templateData.senderCountryEligible === false) {
              this.displayCountryError();
            }
          }
        );
        break;

      case signUpAppEvents.APP_STATUS:
        if (_get(action, 'payload.isAppBusy')) {
          this.props.toggleSpinner(true);
        }
        break;

      case signUpAppEvents.REQUEST_COMPLETE:
        this.handleSignUpResponse(action.payload);
        break;

      case signUpAppEvents.FIELD_UPDATES:
        this.handleSignUpAppFieldUpdates(action.payload);
        break;

      case signUpAppEvents.ERROR:
        this.handleSignUpAppErrors(action.payload);
        break;

      default:
        return;
    }
  };

  handleSignUpResponse = ({ pageFlowData = {}, formFields = {} }) => {
    const {
      sessionStatus: { paypalAccount, guestAccount },
    } = pageFlowData;

    const isFullUser = paypalAccount === 'exists';
    const isGuestUser = guestAccount === 'exists';

    /*
     * Continue with donation
     * Account is created successfully
     * Card is added
     * User is logged in or not
     *
     * In-case of guest user - if not logged in - will try to get payeeId from mayFly
     * TODO: adding middleware - to accept unauthorized guest user and make final attempt to login by getting payeeId from mayFly
     */
    if (isFullUser || isGuestUser) {
      return this.processPayment();
    }

    // Error. Onboarding did not create any account
    this.props.handlePaymentFailure();
  };

  handleSignUpAppErrors = (payload) => {
    switch (payload.type) {
      case signUpAppEvents.API_ERROR:
        this.handleSignUpAppAPIErrors(payload);
        break;

      case signUpAppEvents.CLIENT_ERROR:
      default:
        // do nothing
        break;
    }
  };

  handleSignUpAppAPIErrors = (payload = {}) => {
    const { pageFlowData = {} } = payload;

    // An error occurred
    // Hide the spinner
    this.props.toggleSpinner(false);

    const {
      sessionStatus: { paypalAccount, card },
    } = pageFlowData;
    const errors = payload.errors;
    // If all the errors are field level errors
    // then
    // onboarding will display the error message
    // So dont go to error page
    const areAllErrorsFieldErrors = _every(errors, {
      errorCode: 'FIELD_ERRORS',
    });
    if (areAllErrorsFieldErrors) {
      setTimeout(() => {
        // Wait for onboarding to render the error
        this.props.handleScrollToError();
      }, 300);
      return;
    }

    const isFullUser = paypalAccount === 'exists';
    const isCardAdded = card === 'exists';

    const paypalAccountData = _get(
      pageFlowData,
      'errors.paypalAccountData',
      {}
    );
    const cardData = _get(pageFlowData, 'errors.cardData', {});
    const hasErrors = !!(paypalAccountData.errorCode || cardData.errorCode);

    /*
     * ERROR CASE 1:- Guest full user add card failed
     * Full user account is created successfully
     * Card additon failed
     * Updating flux store with any card error
     * User is logged in
     * User will be redirected to /member
     * Member route will take care - to add new funding instrument
     */
    if (isFullUser && !isCardAdded) {
      DonateAppActions.updateAddCardError('exists');
      return this.handleMemberFailure();
    }

    // log fpti errors and scroll to field level errors
    if (hasErrors) {
      if (cardData.errorCode) {
        FPT.trackError({
          message: cardData.message,
          fieldId: 'global error',
          code: cardData.errorCode,
        });
      }

      if (paypalAccountData.errorCode) {
        FPT.trackError({
          message: paypalAccountData.message,
          fieldId: 'global error',
          code: paypalAccountData.errorCode,
        });
      }

      this.props.handleScrollToError();
    }

    this.updateErrorMessages(cardData, paypalAccountData);
  };

  handleSignUpAppFieldUpdates = (payload) => {
    const { fieldId = '', value: fieldValue = '' } = payload;
    switch (fieldId) {
      /*
       *  for handling the country change based on the store value change for the country dropdown.
       *
       */
      case 'paypalAccountData_donateCountryselector':
        if (fieldValue && this.state.country !== fieldValue) {
          this.setState({
            country: fieldValue,
          });
          this.props.handleCountryChange(fieldValue);
        }

        return;

      /*
       * Need to persist value shareAddress checkbox
       * after completion of `/welcome/donate, redux store is reset and shareAddress checkbox value changes to false
       */
      case 'paypalAccountData_shareAddress':
        if (this.state.shareAddress !== fieldValue) {
          this.setState({
            shareAddress: fieldValue,
          });
        }
        return;

      case 'cardData_csc':
        if (this.state.cardCsc !== fieldValue) {
          this.setState({
            cardCsc: fieldValue,
          });
        }
        return;

      case 'cardData_cardNumber':
        const cardSpec = getSpecificCardSpec(cardSpecs, fieldValue);
        DonateAppActions.changeCardSpec({ cardSpec });

        return;

      default:
        return;
    }
  };

  componentWillUnmount() {
    AppDispatcher.unregister(this.dispatcherMessages);
    this.removeSignUpAppListeners();
  }

  getFormattedAmount = () => {
    const currency = AppStore.getDonationCode() || '';
    const amount = AppStore.getDonationAmount();
    let formattedAmount = '';
    if (amount) {
      formattedAmount = formatAmount({ currency, value: amount });
    }
    return formattedAmount;
  };

  /**********
	Calls dispatch on progressive redux store to add values to specific fields
	Also adds donor name to store, and determines to render the 'memberMandatory view
	**********/
  setInitialState = () => {
    const senderDetails = initialData.senderDetails || {};
    const prefillAddress = senderDetails.address || {};
    const prefillPhone = senderDetails.phone || {};

    if (!templateData.isCountryChange) {
      this.dispatchToSignUpApp({
        type: 'UPDATE_EXTERNAL_VALUES',
        value: {
          paypalAccountData_address1: {
            value: prefillAddress.address1 || '',
          },
          paypalAccountData_address2: {
            value: prefillAddress.address2 || '',
          },
          paypalAccountData_city: {
            value: prefillAddress.city || '',
          },
          paypalAccountData_state: {
            value: prefillAddress.state || '',
          },
          paypalAccountData_zip: {
            value: prefillAddress.zip || '',
          },
          paypalAccountData_firstName: {
            value: senderDetails.first_name || '',
          },
          paypalAccountData_lastName: {
            value: senderDetails.last_name || '',
          },
          paypalAccountData_email: {
            value: senderDetails.sender_email || '',
          },
          paypalAccountData_phone: {
            value:
              getPhoneNumberWithoutCountryCode(prefillPhone.phone_number) || '',
          },
        },
      });
    }

    // Dispatched always
    const value = {
      paypalAccountData_memberMandatory: {
        value: this.state.memberMandatory || false,
      },
      paypalAccountData_shareAddress: { visible: this.state.isShipping },
      password_TCPA_Fields_dynamicSection: false,
      paypalAccountData_guestTermsAgree: { visible: true },
      paypalFormData_paragraphOne: { visible: true },
      paypalFormData_fieldGroupHeading: { visible: false },
    };

    if (templateData.onboardingEnableSkipAuth) {
      value.cardData_skipAuth = {
        name: '/cardData/skipAuth',
        fieldId: 'cardData_skipAuth',
        value: true,
        serverPayload: true,
        basedOnFieldId: 'paypalAccountData_memberMandatory',
      };
    }

    this.dispatchToSignUpApp({
      type: 'UPDATE_EXTERNAL_VALUES',
      value,
    });

    this.dispatchToSignUpApp({
      type: 'UPDATE_FORM_FIELD_STATES',
      value: [
        {
          donorName: templateData.donationName,
        },
      ],
    });

    if (
      this.state.memberMandatory ||
      AppStore.getDonationRecurring() === 'checked'
    ) {
      this.dispatchToSignUpApp({
        type: 'UPDATE_EXTERNAL_VALUES',
        value: {
          paypalAccountData_memberMandatory: { visible: false, value: true },
          password_TCPA_Fields_dynamicSection: true,
          paypalAccountData_guestTermsAgree: { visible: false },
          paypalFormData_paragraphOne: { visible: false },
          paypalFormData_fieldGroupHeading: { visible: true },
        },
      });
    }
  };

  /**
   * Appends error messages from onboarding redux store
   * to react's errorMessage state
   *
   * @author: mdemers
   * @param {Object} cardData The cardData error object from redux store
   * @param {Object} paypalAccountData The paypalAccountData error object from redux store
   */
  updateErrorMessages = (cardData, paypalAccountData) => {
    const errorMessages = this.state.errorMessages;

    if (cardData.errorCode) {
      if (isTeslaErrorMessage(cardData.errorCode)) {
        if (!_find(errorMessages, { value: cardData.message })) {
          errorMessages.push({ value: cardData.message });
        }
      } else {
        this.props.handlePaymentFailure();
      }
    }

    if (paypalAccountData.errorCode) {
      if (isTeslaErrorMessage(paypalAccountData.errorCode)) {
        if (!_find(errorMessages, { value: paypalAccountData.message })) {
          errorMessages.push({ value: paypalAccountData.message });
        }
      } else {
        this.props.handlePaymentFailure();
      }
    }

    const showServiceErrors =
      this.state.errorMessages.length > 0 ? true : false;

    this.setState({
      errorMessages: errorMessages,
      showServiceErrors: showServiceErrors,
    });
  };

  /*
   * handleMemberFailure
   * Redirect all member failure to donate/member
   * Known case
   * Case 1 :- WSM_PAYER_FUNDING_INSTRUMENTS_UNAVAILABLE
   * Case 2 :- WSM_VALIDATION_ERROR
   */
  handleMemberFailure = () => {
    this.props.handleMemberFailure();
  };

  /*
   * updateShareAddress
   * setting value of shareAddress checkbox before onboarding dispatched any event
   * shareAddress checkbox value is used by planning
   */
  updateShareAddress = () => {
    DonateAppActions.updateShareAddress(this.state.shareAddress);
  };

  triggerAccountCreation = (event) => {
    event.preventDefault();
    if (!this.props.validateAmountV2()) {
      return;
    }

    if (
      document.getElementById('country-error-msg') ||
      templateData.senderCountryEligible === false
    ) {
      return;
    }

    const fieldId =
      event.target.id ||
      event.target.name ||
      event.target.innerText ||
      event.target.href;

    FPT.addDonationAmount(
      AppStore.getDonationAmount(),
      window.fpti.pgrp,
      window.fpti.page
    );

    DonateAppActions.updateServerErrors({
      serverErrors: [],
    });
    this.updateShareAddress();
    this.dispatchToSignUpApp({
      type: 'UPDATE_STATE_WITH_EXTERNAL_VALUES',
    });
    this.dispatchToSignUpApp({
      type: signUpAppEvents.REQUEST_INITIATE,
      payload: {
        submitName: '/appData/action',
        submitActionVal: 'submit_account_create',
        additionalPostData: [
          { key: '/paypalAccountData/createUpdateReady', value: true },
          { key: '/cardData/createUpdateReady', value: true },
        ],
        fieldId,
      },
    });
  };

  /*
   * processDonation
   */
  processPayment = (params = {}) => {
    // Send 'selectedProgram' param to server
    const selectedProgram = AppStore.getSelectedProgram();
    // Only send if required. Otherwise it gets converted to string "undefined"
    if (selectedProgram) {
      params.selectedProgram = selectedProgram;
    }

    params.card = {};
    params.card.securityCode = this.state.cardCsc;

    teslaGuestPayment(params)
      .then((response = {}) => {
        if (response.code === 'CROSS_BORDER' && response.fundingOpts) {
          const fundingOptions = response.fundingOpts[0];

          // Updating store with funding options and redirecting to review page
          DonateAppActions.updateFundingOptions({ fundingOptions });

          this.props.toggleSpinner(false);

          window.PAYPAL.analytics.startCPLTracking({
            page: 'main:donate:wps:guest:crossBorder:web::',
            action: 'crossborder_page_loaded',
            uicomp: 'crossBorder',
            uitype: 'page',
          });
          return this.props.history.push('/donate/guest/crossborder');
        } else if (
          response.code === '3D_SECURE_DATA_COLLECTION_REQUIRED' &&
          response.fundingOpts
        ) {
          let fundingOptions = response.fundingOpts[0];
          // Updating store with funding options
          DonateAppActions.updateFundingOptions({
            fundingOptions: fundingOptions,
          });
          FPT.addFi(
            fundingOptions,
            'main:onbrd:signup:donate:3DS-challenge',
            'main:onbrd:signup:donate:3DS-challenge:::'
          );
          FPT.add3DSInitData(
            fundingOptions,
            'main:onbrd:signup:donate:3DS-challenge',
            'main:onbrd:signup:donate:3DS-challenge:::'
          );

          // handle 3DS
          this.threeDSContainer.initializeThreeDS();

          return;
        } else if (response.error && response.error.auth_state === 'LOGGEDIN') {
          // Spinner gets hidden after navigating to member page
          return this.props.handleMemberFailure();
        } else if (response.error && response.code === 'CVV_CONTINGNECY') {
          this.props.toggleSpinner(false);

          const errorMessages = this.state.errorMessages;
          errorMessages.push({
            value: 'Please check credit card information or try another card',
          });

          DonateAppActions.updateServerErrors({
            serverErrors: errorMessages,
          });

          return;
        } else if (response.data.error) {
          // mocking fulfillment error and render user back to tesla form
          this.props.toggleSpinner(true);

          const { token, country } = templateData;

          let clientState = encodeURIComponent(
            `/donate/guest?token=${token}&showErrorOnLoad=fulfillment`
          );
          window.location.href = `/donate/?token=${token}&country.x=${country}&locale.x=${country}&clientState=${clientState}`;

          // window.location.href = this.props.getDonateGuestUrl();
          return;
        } else if (response.confirmation) {
          startCustomCPLTrackingForConfirmationPage();
          this.props.toggleSpinner(false);

          DonateAppActions.updateConfirmation({
            confirmation: response.confirmationData,
          });
          return this.props.handlePaymentSuccess(response);
        }

        return this.props.handlePaymentFailure();
      })
      .catch(() => {
        return this.props.handlePaymentFailure();
      });
  };

  handleThreeDSStepUpAuthSuccess = () => {
    this.props.toggleSpinner(true);
    this.props.doFulfilment({
      securityCode: this.state.securityCode,
    });
  };
  handleThreeDSFailure = () => {
    // Unrecoverable error !!
    this.props.history.push('/donate/error/threeDS');
  };

  displayCountryError() {
    const countrySelectNode = document.getElementById(
        'paypalAccountData_donateCountryselector'
      ),
      countryNode = countrySelectNode && countrySelectNode.parentNode,
      errorNode = document.createElement('div'),
      countryErrorMsgHtml = `<div class="ppvx_dropdown__error-text" id="country-error-msg" data-testid="country-error-msg">${sendDonationNotAllowed}</div>`;

    errorNode.innerHTML = countryErrorMsgHtml;

    if (countryNode) {
      countryNode.appendChild(errorNode);
      countrySelectNode.style.borderColor = red500;
      countryNode.setAttribute(
        'class',
        `${countryNode.getAttribute('class')} country-field-error`
      );
    }
  }

  renderProgressive = () => {
    let progressiveOnboardingProps = {
      modelData: {},
      token: templateData.token,
      flow: 'donate',
      // setInitialState: this.setInitialState,
      // endpoint: `/welcome/donate?country.x=${templateData.country}&locale.x=${templateData.language}_${templateData.country}`,
      griffinData: true,
      griffinPhoneHandler: getGriffinPhoneHandler(),
      listenerIds: this.state.listenerIds,
    };

    if (
      templateData.token === templateData.tokenForSavedFormData &&
      templateData.teslaVisited === true
    ) {
      progressiveOnboardingProps.endpoint = `/welcome/donate?country.x=${templateData.country}&locale.x=${templateData.language}_${templateData.country}&entry=${this.state.entry}`;
    } else {
      progressiveOnboardingProps.endpoint = `/welcome/donate?country.x=${templateData.country}&locale.x=${templateData.language}_${templateData.country}&entry=${this.state.entry}`;
    }

    return (
      <div className="donate_onboarding_guest_form">
        <SignupApp {...progressiveOnboardingProps} />
        <GuestSubmitButton
          amount={this.state.formattedAmount}
          labels={allGuestMessages.guestLabels}
          isRecurring={this.state.recurringStatus}
          // disabled={this.props.donateDisabled}
          country={this.state.country}
          handleClick={this.triggerAccountCreation}
          // passwordFieldsOpen={this.state.passwordFieldsOpen}
        />
        <ThreeDSContainer
          onThreeDSStepUpAuthNotRequired={this.handleThreeDSStepUpAuthSuccess}
          onThreeDSStepUpAuthSuccess={this.handleThreeDSStepUpAuthSuccess}
          onThreeDSStepUpAuthFailure={this.handleThreeDSFailure}
          onThreeDSFailure={this.handleThreeDSFailure}
          onRef={(ref) => (this.threeDSContainer = ref)}
        />
      </div>
    );
  };

  render() {
    return this.renderProgressive();
  }
}

TeslaForm.propTypes = {
  signupApp: PropTypes.func,
  handlePaymentFailure: PropTypes.func,
  handleMemberFailure: PropTypes.func,
  toggleSpinner: PropTypes.func,
  handleCountryChange: PropTypes.func,
  handleScrollToError: PropTypes.func,
  validateAmountV2: PropTypes.func,
  handlePaymentSuccess: PropTypes.func,
  history: PropTypes.object,
  getDonateGuestUrl: PropTypes.func,
  signUpAppEvents: PropTypes.object,
  doFulfilment: PropTypes.func,
};

export default withRouter(withDonate(TeslaForm));
